module.exports = __webpack_public_path__ + "statics/img/1-6.c81210e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/1-6.png
// module id = 6Fgf
// module chunks = 1